import React from 'react';
import './ammNumerologyDesignSystem.css';
import './ammNumerologyCompositions.css';

const HERO_IMAGE =
  'https://d1yei2z3i6k35z.cloudfront.net/15470577/69c288887c8589.01587466_numerology-stones-with-numbers-on-wooden-zodiac.jpg';

/**
 * Section 1 — Numerology: editorial intro only (no course or report pitch).
 */
export default function NumerologyHubHero() {
  return (
    <header className="amm-hub-hero-editorial" aria-labelledby="hub-hero-title">
      <div className="amm-hub-hero-editorial__image-shell">
        <div className="amm-hub-hero-editorial__frame">
          <img
            className="amm-hub-hero-editorial__img"
            src={HERO_IMAGE}
            alt=""
            width={1600}
            height={640}
            decoding="async"
          />
        </div>
      </div>

      <div className="amm-hub-hero-editorial__inner">
        <p className="amm-hub-hero-editorial__kicker">About numerology</p>
        <h1 id="hub-hero-title" className="amm-hub-hero-editorial__title">
          Numerology
        </h1>
        <p className="amm-hub-hero-editorial__lead">
          Numerology works with numbers taken from your birth date and name. Those numbers describe tendencies, repeating
          themes, and the shape of a life in outline—not prediction, but a structured language for reading a chart.
        </p>
        <p className="amm-hub-hero-editorial__support">
          The same digits appear in different positions—life path, name lines, timing—so interpretation stays tied to how
          a chart is built, not to slogans or single labels in isolation.
        </p>

        <div className="amm-hub-hero-editorial__chips amm-hub-hero-editorial__chips--topics" aria-label="Themes in numerology">
          <span className="amm-hub-hero-editorial__chip amm-hub-hero-editorial__chip--soft">Core numbers</span>
          <span className="amm-hub-hero-editorial__chip amm-hub-hero-editorial__chip--soft">Timing &amp; cycles</span>
          <span className="amm-hub-hero-editorial__chip amm-hub-hero-editorial__chip--soft">Interpretation</span>
          <span className="amm-hub-hero-editorial__chip amm-hub-hero-editorial__chip--soft">Full reading</span>
        </div>
      </div>
    </header>
  );
}
